var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "../common/elements/Header.scss";
import translate from "src/i18n/translate";
import Header from "src/features/common/elements/Header";
import OrgDetailContent from "src/features/common/elements/OrgDetailContent";
import ScrollableHeader from "../common/elements/ScrollableHeader";
import { useContext, useEffect, useReducer } from "react";
import { onScrollChangeBreadCrumb } from "../../static/js/commons";
import { AppContext } from "src/contexts/AppContext";
import PreviewModal from "../lightcast/PreviewModal";
import UnauthorizedComponent from "src/features/insights/UnauthorizedComponent";
import { defaultOrganization } from "../common/interfaces/Interface";
import { checkIfFsProductIntegrated, checkIfCesProductIntegrated } from "../common/helper";
import { sendRequest } from "../../common/http";
import { useParams } from "react-router-dom";
import Loader from "../common/elements/Loader";
import ApiError from "../common/elements/ApiError";
import { usePageTitle } from 'src/hooks/usePageTitle';
import { useIntl } from 'react-intl';
var defaultAction = {
    type: "",
    organization: defaultOrganization,
    component: ""
};
var reducer = function (state, action) {
    switch (action.type) {
        case "setOrganization":
            return __assign(__assign({}, state), { organization: action.organization, showMainLoader: false });
        case "setApiError":
            return __assign(__assign({}, state), { apiError: true, showMainLoader: false });
        default:
            return state;
    }
};
var initialState = {
    organization: defaultOrganization,
    showMainLoader: true,
    apiError: false
};
export default function OrgDetailComponent(_a) {
    var _b;
    var setSelectedTabView = _a.setSelectedTabView, auth = _a.auth;
    var _c = useContext(AppContext), institution = _c.institution, integratedProducts = _c.integratedProducts;
    var intl = useIntl();
    var _d = useParams(), institutionUuid = _d.institution_uuid, orgUuid = _d.organization_uuid;
    var _e = useReducer(reducer, initialState), state = _e[0], dispatch = _e[1];
    // Use dynamic title based on organization name when available
    var pageTitle = ((_b = state.organization) === null || _b === void 0 ? void 0 : _b.name)
        ? "".concat(state.organization.name, " - ").concat(intl.formatMessage({ id: 'app.pageTitle.organizationInsights' }))
        : intl.formatMessage({ id: 'app.pageTitle.organizationInsights' });
    usePageTitle(pageTitle);
    useEffect(function () {
        setTimeout(function () {
            onScrollChangeBreadCrumb(institution === null || institution === void 0 ? void 0 : institution.navigatedFrom);
        }, 1000);
    }, []);
    useEffect(function () {
        if (institutionUuid && orgUuid && institution) {
            var onError = function () {
                dispatch(__assign(__assign({}, defaultAction), { type: "setApiError" }));
            };
            if (institution.navigatedFrom === "navigator") {
                var applyResult = function (result) {
                    dispatch(__assign(__assign({}, defaultAction), { type: "setOrganization", organization: result }));
                };
                sendRequest({
                    uri: "/org_insights/institution/".concat(institutionUuid, "/organization/").concat(orgUuid, "/organization_info"),
                    camelize: true
                }, applyResult, onError);
            }
            else if (institution.navigatedFrom === "planning") {
                var applyResult = function (result) {
                    dispatch(__assign(__assign({}, defaultAction), { type: "setPssOrganization", organization: result }));
                };
                sendRequest({
                    uri: "/org_insights/pss/organization/".concat(orgUuid),
                    camelize: true
                }, applyResult, onError);
            }
        }
    }, [institutionUuid, orgUuid]);
    var displayName = (state.organization && state.organization.name) || (institution && institution.name);
    return (_jsxs(_Fragment, { children: [state.showMainLoader && _jsx(Loader, {}), state.apiError ? (_jsx(ApiError, {})) : (_jsx(_Fragment, { children: auth ? (_jsxs("main", { id: "maincontent", className: "main-body-container-home", children: [_jsx(Header, { displayName: displayName }), _jsx(ScrollableHeader, { displayName: displayName }), _jsx("div", { className: "insights-hub-body flex-row", children: _jsx("div", { id: "main-org-profile-container", className: "main-org-profile", children: _jsxs("div", { children: [_jsxs("div", { className: "page-banner -insights-header insights-header-home", children: [_jsx("h2", { className: "titles", children: "Insights" }), _jsx("div", { className: "description", children: translate("app.header.description") })] }), (checkIfFsProductIntegrated(integratedProducts) || checkIfCesProductIntegrated(integratedProducts)) ? (_jsx("div", { className: "body -height", id: "tab-components", children: _jsx(OrgDetailContent, { setSelectedTabView: setSelectedTabView }) })) : (_jsx(EmptyState, { institution: institution }))] }) }) }), _jsx(PreviewModal, {})] })) : (_jsx(UnauthorizedComponent, {})) }))] }));
}
var EmptyState = function (_a) {
    var institution = _a.institution;
    return (_jsx("div", { className: "body", id: "tab-components", children: _jsx("section", { className: (institution === null || institution === void 0 ? void 0 : institution.navigatedFrom) === "navigator"
                ? "body wm-grid tab-body"
                : "body wm-grid tab-body-home", id: "section_insights", children: _jsxs("div", { className: "empty-state-content-no-fs", children: [_jsx("div", { className: "empty-state-title", children: translate("app.noFsIntegration.title") }), _jsx("div", { className: "empty-state-description", children: translate("app.noFsIntegration.description") })] }) }) }));
};
